import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sheed-tile',
  templateUrl: './sheed-tile.component.html',
  styleUrls: ['./sheed-tile.component.scss']
})
export class SheedTileComponent implements OnInit {
  @Input('title') title: string;
  @Input('text') text: string;
  @Input('loading') loading: boolean=true;
  constructor() { }

  ngOnInit() {
  }

}
